import { Component, Inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationModule } from 'angular-l10n';

@Component({
  selector: 'supplierDB-registration-disclaimer',
  standalone: true,
  imports: [L10nTranslationModule],
  templateUrl: './disclaimer.component.html',
})
export class DisclaimerComponent {
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
